import AgencyHelper, { AgencyConstants } from 'features/Agency/agencyHelper';
import useAgency from 'features/Agency/useAgency';
import ChargeHelper from 'features/Charge/chargeHelper';
import useCharge from 'features/Charge/useCharge';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import AppColors from 'general/constants/AppColors';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

ChargeStationCompactListFilterView.propTypes = {
  onCancel: PropTypes.func,
  onApply: PropTypes.func,
  initialFilter: PropTypes.object,
  hideManagementObject: PropTypes.bool,
};

function ChargeStationCompactListFilterView({
  onCancel,
  onApply,
  initialFilter,
  hideManagementObject = false,
}) {
  // MARK: ---- PROPERTIES ----
  const [filterStatus, setFilterStatus] = useState('');
  const [filterOperatorId, setFilterOperatorId] = useState('');
  const [filterVehicleType, setFilterVehicleType] = useState('');
  const [filterQ, setFilterQ] = useState('');
  const [filterAgencyId, setFilterAgencyId] = useState('');
  const [filterLandlordId, setFilterLandlordId] = useState('');
  const [filterAreaId, setFilterAreaId] = useState('');
  useEffect(() => {
    setFilterStatus(initialFilter.status);
    setFilterOperatorId(initialFilter.operatorId);
    setFilterVehicleType(initialFilter.vehicleType);
    setFilterQ(initialFilter.q);
    setFilterAgencyId(initialFilter.agencyId);
    setFilterLandlordId(initialFilter.landlordId);
    setFilterAreaId(initialFilter.areaId);
  }, [initialFilter]);
  const { operatorList, operatorOptions } = useAgency();
  const { managementObjectOptions } = useCharge();
  const [selectedManagementObject, setSelectedManagementObject] = useState('');
  const [agencyList, setAgencyList] = useState();
  const agencyOptions = useMemo(() => {
    const options = (agencyList ?? []).map((row) => {
      return {
        name: row?.name,
        subTitle: row.agencyId,
        value: row?.agencyId,
      };
    });
    return options;
  }, [agencyList]);
  const [selectedAgency, setSelectedAgency] = useState();
  // khu vuc
  const areaTree = useSelector((state) => state.app.areaTree);
  const areaProvinceList = useMemo(() => {
    return ChargeHelper.Utils.getAreaListByType([areaTree], 'P');
  }, [areaTree]);
  const areaProvinceOptions = useMemo(() => {
    return _.map(areaProvinceList, (item) => {
      return {
        name: item.name,
        value: item.areaId,
      };
    });
  }, [areaProvinceList]);
  const [selectedAreaProvince, setSelectedAreaProvince] = useState();
  const areaDistrictList = useMemo(() => {
    if (!selectedAreaProvince) return [];
    return ChargeHelper.Utils.getSubAreaListByParentId([areaTree], selectedAreaProvince?.areaId);
  }, [areaTree, selectedAreaProvince]);
  const areaDistrictOptions = useMemo(() => {
    return _.map(areaDistrictList, (item) => {
      return {
        name: item.name,
        value: item.areaId,
      };
    });
  }, [areaDistrictList]);
  const [selectedAreaDistrict, setSelectedAreaDistrict] = useState();
  useEffect(() => {
    const areaId = ChargeHelper.Filter.chargeStationList.areaId;
    if (Utils.isValid(areaId)) {
      const area = ChargeHelper.Utils.getAreaById([areaTree], areaId);
      if (area?.type === 'P') {
        setSelectedAreaProvince(area);
      } else {
        setSelectedAreaDistrict(area);
        const parentAreaId = area?.parentId;
        if (Utils.isValid(parentAreaId)) {
          setSelectedAreaProvince(ChargeHelper.Utils.getAreaById([areaTree], parentAreaId));
        }
      }
    }
  }, [ChargeHelper.Filter.chargeStationList, areaTree]);
  useEffect(() => {
    const agencyId = ChargeHelper.Filter.chargeStationList.agencyId;
    if (Utils.isValid(agencyId)) {
      AgencyHelper.API.requestAgencyDetail(agencyId).then((agency) => {
        if (agency) {
          setSelectedAgency(agency);
          setSelectedManagementObject(agency.primaryRole);
        }
      });
    }
  }, [ChargeHelper.Filter.chargeStationList]);
  useEffect(() => {
    if (!_.isNil(selectedAgency) && _.isNil(agencyList)) {
      handleGetAgencyList(selectedAgency.primaryRole);
    }
  }, [selectedAgency, agencyList]);

  // MARK: ---- METHODS ----
  const handleGetAgencyList = (role) => {
    if (!_.isEmpty(role)) {
      const param = {
        role,
      };
      AgencyHelper.API.requestGetAgencyList(param).then((response) => {
        setAgencyList(response?.agencies ?? []);
      });
    }
  };
  const handleApplyFilter = () => {
    if (onApply)
      onApply({
        status: filterStatus,
        operatorId: filterOperatorId,
        vehicleType: filterVehicleType,
        q: filterQ,
        agencyId: filterAgencyId,
        landlordId: filterLandlordId,
        areaId: filterAreaId,
      });
  };
  const handleClearFilter = () => {
    setSelectedAgency(null);
    setSelectedManagementObject('');
    setSelectedAreaProvince(null);
    setSelectedAreaDistrict(null);
    setFilterStatus('');
    setFilterOperatorId('');
    setFilterQ('');
    setFilterAgencyId('');
    setFilterLandlordId('');
    setFilterAreaId('');
    if (onCancel) onCancel();
  };

  return (
    <div className="py-4">
      <div className="row m-0 px-2">
        {/* tim kiem */}
        <div className="col-12 mb-4 px-2">
          <KTFormSearch
            name="search_filter"
            placeholder="Theo mã trạm sạc, tên trạm sạc, địa chỉ..."
            value={filterQ}
            onSubmit={(text) => {
              setFilterQ(text);
            }}
          />
        </div>
        {/* nha dieu hanh */}
        <div className="col-sm-6 mb-4 p-0 px-2">
          {UIHelper.buildFormLabel('Nhà điều hành')}
          <KTBSDropdown
            name="operator_filter"
            toggleElement={
              <button
                className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                type="button"
              >
                {_.find(operatorList, (item) => item.operatorId === filterOperatorId)?.name ??
                  'Tất cả'}
              </button>
            }
            selectedValue={ChargeHelper.Filter.chargeStationList?.operatorId}
            dropdownMenuItems={[{ name: 'Tất cả', value: '' }, ...operatorOptions]}
            dropdownMenuClassName="overflow-auto w-100"
            dropdownMenuStyle={{ maxHeight: '30vh' }}
            onChange={(value) => {
              setFilterOperatorId(value);
            }}
            isDropdownForm={true}
          />
        </div>
        {!hideManagementObject && (
          <>
            {/* doi tuong quan ly */}
            <div className="col-sm-6 mb-4 p-0 px-2">
              {UIHelper.buildFormLabel('Đối tượng quản lý')}
              <KTBSDropdown
                name="managementObject_filter"
                toggleElement={
                  <button
                    className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between`}
                    type="button"
                  >
                    {_.find(
                      managementObjectOptions,
                      (item) => item.value === selectedManagementObject
                    )?.name ?? 'Tất cả'}
                  </button>
                }
                selectedValue={selectedManagementObject}
                dropdownMenuItems={[{ name: 'Tất cả', value: '' }, ...managementObjectOptions]}
                dropdownMenuClassName="overflow-auto w-100"
                dropdownMenuStyle={{ maxHeight: '30vh' }}
                onChange={(value) => {
                  setSelectedManagementObject(value);
                  setSelectedAgency(null);
                  handleGetAgencyList(value);
                }}
                isDropdownForm={true}
              />
            </div>
            {/* ndt nq hoac chu dat */}
            {/* <div className="col-sm-6 mb-4 p-0 px-2">
              {UIHelper.buildFormLabel(
                selectedManagementObject === AgencyConstants.AgencyRole.INVESTOR
                  ? 'Nhà đầu tư NQ'
                  : 'Chủ mặt bằng'
              )}
              <KTBSDropdown
                name="agencyId_filter"
                toggleElement={
                  <button
                    className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${selectedManagementObject === '' ? 'disabled' : ''
                      }`}
                    type="button"
                  >
                    {selectedAgency
                      ? selectedAgency?.name
                      : selectedManagementObject === AgencyConstants.AgencyRole.INVESTOR
                        ? 'Chọn nhà đầu tư NQ'
                        : selectedManagementObject === AgencyConstants.AgencyRole.LANDLORD
                          ? 'Chọn chủ mặt bằng'
                          : 'Chọn đối tượng'}
                  </button>
                }
                selectedValue={selectedAgency?.agencyId}
                dropdownMenuItems={agencyOptions}
                dropdownMenuClassName="overflow-auto w-100 pb-0"
                dropdownMenuStyle={{ maxHeight: '30vh' }}
                onChange={(value) => {
                  setSelectedAgency(_.find(agencyList, (item) => item.agencyId === value));
                  setFilterAgencyId(value);
                }}
                isDropdownForm={true}
                searchable
                liveSearch={false}
                onTextChanged={(text) => { }}
                disabled={selectedManagementObject === ''}
              />
            </div> */}
          </>
        )}
        {/* loai phuong tien */}
        <div className="col-sm-6 mb-4 p-0 px-2">
          {UIHelper.buildFormLabel('Loại phương tiện')}
          <KTBSDropdown
            name="operator"
            toggleElement={
              <button
                className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                type="button"
              >
                {_.find(
                  ChargeHelper.Data.vehicleTypeOptions,
                  (item) =>
                    item?.value === filterVehicleType
                )?.name ?? 'Tất cả'}
              </button>
            }
            selectedValue={filterVehicleType}
            dropdownMenuItems={[{ name: 'Tất cả', value: '' }, ...ChargeHelper.Data.vehicleTypeOptions]}
            dropdownMenuClassName="overflow-auto w-100"
            dropdownMenuStyle={{ maxHeight: '30vh' }}
            onChange={(value) => {
              setFilterVehicleType(value);
            }}
            isDropdownForm={true}
          />
        </div>
        {/* trang thai */}
        <div className="col-sm-6 mb-4 p-0 px-2">
          {UIHelper.buildFormLabel('Trạng thái trạm sạc')}
          <KTBSDropdown
            name="status_filter"
            toggleElement={
              <button
                className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                type="button"
              >
                {_.find(
                  ChargeHelper.Data.chargeStationStatusOptions,
                  (item) => item.value === filterStatus
                )?.name ?? 'Tất cả'}
              </button>
            }
            selectedValue={ChargeHelper.Filter.chargeStationList?.status}
            dropdownMenuItems={[
              { name: 'Tất cả', value: '' },
              ...ChargeHelper.Data.chargeStationStatusOptions,
            ]}
            dropdownMenuClassName="overflow-auto w-100"
            dropdownMenuStyle={{ maxHeight: '30vh' }}
            onChange={(value) => {
              setFilterStatus(value);
            }}
            isDropdownForm={true}
          />
        </div>

        {/* tinh/thanh pho */}
        <div className="col-sm-6 mb-4 p-0 px-2">
          {UIHelper.buildFormLabel('Tỉnh/Thành phố')}
          <KTBSDropdown
            name="province_filter"
            toggleElement={
              <button
                className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between`}
                type="button"
              >
                {selectedAreaProvince?.name ?? 'Chọn tỉnh/thành phố'}
              </button>
            }
            selectedValue={selectedAreaProvince?.areaId}
            dropdownMenuItems={areaProvinceOptions}
            dropdownMenuClassName="overflow-auto w-100"
            dropdownMenuStyle={{ maxHeight: '30vh' }}
            onChange={(value) => {
              setSelectedAreaProvince(_.find(areaProvinceList, (item) => item.areaId === value));
              setFilterAreaId(value);
            }}
            isDropdownForm={true}
            searchable
            liveSearch={false}
            onTextChanged={(text) => { }}
          />
        </div>
        {/* quan/huyen */}
        <div className="col-sm-6 mb-4 p-0 px-2">
          {UIHelper.buildFormLabel('Phường/Xã', true)}
          <KTBSDropdown
            name="district"
            toggleElement={
              <button
                className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between`}
                type="button"
              >
                {selectedAreaDistrict?.name ?? 'Chọn phường/xã'}
              </button>
            }
            selectedValue={selectedAreaDistrict?.areaId}
            dropdownMenuItems={areaDistrictOptions}
            dropdownMenuClassName="overflow-auto w-100"
            dropdownMenuStyle={{ maxHeight: '30vh' }}
            onChange={(value) => {
              const area = _.find(areaDistrictList, (item) => item.areaId === value);
              setSelectedAreaDistrict(area);
              setFilterAreaId(value);
            }}
            isDropdownForm={true}
            searchable
            liveSearch={false}
            onTextChanged={(text) => { }}
          />
        </div>
      </div>
      {/* actions */}
      <div
        className="px-4 pt-4 pb-0 d-flex align-items-center justify-content-end gap-3"
        style={{
          borderTop: `1px solid ${AppColors.gray[200]}`,
        }}
      >
        {UIHelper.buildNegativeButton('Xóa bộ lọc', handleClearFilter)}
        {UIHelper.buildGreenButton('Áp dụng', handleApplyFilter)}
      </div>
    </div>
  );
}

export default ChargeStationCompactListFilterView;
